import { renderless, api } from "@opentiny/vue-renderless/nav-menu/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconSetting, iconChevronRight, iconSandwichCollapse, iconSandwichExpand } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["data", "parentKey", "overflow", "beforeSkip", "fetchMenuData", "fields", "prevent", "allowFullUrl"]),
  components: {
    IconSetting: iconSetting(),
    IconChevronRight: iconChevronRight(),
    IconSandwichCollapse: iconSandwichCollapse(),
    IconSandwichExpand: iconSandwichExpand()
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "tiny-nav-menu"
  }, [/^(retract|fixed)$/.test(_vm.overflow) ? _c("div", {
    staticClass: "more-button",
    class: {
      mobile: _vm.slots.mobileMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showSubMenu(_vm.state.data[0].children, {
          more: true
        });
      },
      "mouseleave": _vm.willHideSubMenu
    }
  }, [_c(_vm.state.showMore ? "IconSandwichExpand" : "IconSandwichCollapse", {
    tag: "component"
  })], 1) : _vm._e(), _vm.slots.logo ? _c("div", {
    staticClass: "slot-logo"
  }, [_vm._t("logo")], 2) : _vm._e(), _vm.state.data && _vm.state.data.length ? _c("ul", {
    staticClass: "menu",
    style: _vm.state.menuStyle
  }, _vm._l(_vm.state.data, function(item, index) {
    return _c("li", {
      key: index
    }, [_c(_vm.getTag(item), {
      tag: "component",
      class: {
        active: index === _vm.state.activeIndex,
        selected: index === _vm.state.selectedIndex
      },
      attrs: {
        "to": _vm.getRoute(item)
      },
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.showSubMenu(item.children, {
            index
          }, $event);
        },
        "mouseleave": _vm.willHideSubMenu,
        "click": function click($event) {
          return _vm.clickMenu(item, index);
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1);
  }), 0) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.isShowMore,
      expression: "state.isShowMore"
    }],
    staticClass: "more",
    style: {
      marginLeft: _vm.state.marginLeft + "px"
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showSubMenu(_vm.state.more[0].children, {
          more: true
        });
      },
      "mouseleave": _vm.willHideSubMenu
    }
  }, [_vm._v(" " + _vm._s(_vm.t("ui.navMenu.moreText")) + " ")]), _vm.slots.toolbar ? _c("div", {
    staticClass: "slot-toolbar"
  }, [_vm._t("toolbar")], 2) : _vm._e(), _vm.slots.mobileMenu ? _c("div", {
    staticClass: "slot-mobile-menu"
  }, [_vm._t("mobileMenu")], 2) : _vm._e(), _c("transition", {
    attrs: {
      "name": "tiny-transition-zoom-in-top",
      "mode": "out-in"
    }
  }, [_c("ul", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.showPopmenu,
      expression: "state.showPopmenu"
    }],
    staticClass: "popmenu tiny-min-scrollbar",
    class: [_vm.state.popClass, {
      slide: _vm.state.showPopmenu
    }],
    style: _vm.state.popStyle,
    on: {
      "mouseenter": _vm.stopHideSubMenu,
      "mouseleave": _vm.willHideSubMenu
    }
  }, [_vm.state.showMore ? _c("li", {
    staticClass: "more-menu"
  }, [_c("ul", _vm._l(_vm.state.more, function(item, index) {
    return _c("li", {
      key: index,
      class: {
        active: index === _vm.state.subActiveIndex,
        selected: index === _vm.state.moreItemSelectedIndex
      }
    }, [_c(_vm.getTag(item), {
      tag: "component",
      class: {
        showicon: item.children
      },
      attrs: {
        "to": _vm.getRoute(item)
      },
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.setSubMenu(item.children, index);
        },
        "mouseleave": _vm.leaveMoreMune,
        "click": function click($event) {
          return _vm.clickMenu(item, index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), item.children ? _c("icon-chevron-right", {
      staticClass: "more-icon"
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e(), _vm.state.subMenus && _vm.state.subMenus.length ? _c("li", {
    staticClass: "sub-menu",
    class: {
      "full-width": !_vm.state.showMore
    }
  }, [_c("ul", _vm._l(_vm.state.subMenus, function(group, index) {
    return _c("li", {
      key: index,
      class: {
        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2": _vm.state.popClass !== "single"
      }
    }, [_c("ul", {
      staticClass: "group"
    }, [_c("li", {
      staticClass: "tiny-nav-menu__sub-menu-title",
      class: !!group.title ? "" : "tiny-nav-menu__sub-menu-title-blank"
    }, [_c(_vm.getTag(group), {
      tag: "component",
      class: {
        selected: index === _vm.state.subIndex && _vm.state.subItemSelectedIndex === -1
      },
      attrs: {
        "to": _vm.getRoute(group)
      },
      on: {
        "click": function click($event) {
          return _vm.clickMenu(group, -1, index);
        }
      }
    }, [_vm._v(_vm._s(group.title))])], 1), _vm._l(group.children, function(item, i) {
      return _c("li", {
        key: i,
        staticClass: "sub-item",
        class: !group.title && !_vm.state.subMenu[i].children ? "only-secondary-title" : ""
      }, [_c(_vm.getTag(item), {
        tag: "component",
        class: {
          selected: i === _vm.state.subItemSelectedIndex && index === _vm.state.subIndex
        },
        attrs: {
          "to": _vm.getRoute(item)
        },
        on: {
          "click": function click($event) {
            return _vm.clickMenu(item, i, index);
          }
        }
      }, [_vm._v(_vm._s(item.title))])], 1);
    })], 2)]);
  }), 0)]) : _vm._e()])])], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
